import React from 'react';

/**
 * Composant Icon réutilisable
 * Utilise la charte graphique de l'application
 * 
 * IMPORTANT: Assurez-vous d'avoir installé react-icons:
 * npm install react-icons
 */
const Icon = ({ 
  name, 
  size = 20, 
  color = 'currentColor', 
  className = '', 
  style = {},
  ...props 
}) => {
  let IconComponent;
  
  try {
    const { icons } = require('../theme/icons');
    IconComponent = icons[name];
  } catch (error) {
    console.warn('react-icons not installed. Please run: npm install react-icons');
    // Fallback: afficher le nom de l'icône
    return (
      <span 
        className={`inline-flex items-center justify-center ${className}`}
        style={{ width: size, height: size, fontSize: size * 0.7, ...style }}
        {...props}
      >
        {name.charAt(0).toUpperCase()}
      </span>
    );
  }
  
  if (!IconComponent) {
    console.warn(`Icon "${name}" not found`);
    return (
      <span 
        className={`inline-flex items-center justify-center ${className}`}
        style={{ width: size, height: size, fontSize: size * 0.7, ...style }}
        {...props}
      >
        ?
      </span>
    );
  }
  
  return (
    <IconComponent
      size={size}
      color={color}
      className={className}
      style={style}
      {...props}
    />
  );
};

export default Icon;

